import React, { useState } from "react";
import { sendFeedback } from "../api/client";
import { useToast } from "./ToastProvider";

export default function FeedbackPanel() {
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const pushToast = useToast();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!message.trim()) {
      return;
    }

    setIsSending(true);
    try {
      await sendFeedback({
        subject: "asksomething website feedback",
        message: message.trim(),
        page_url: window.location.href
      });
      setMessage("");
      pushToast({
        tone: "success",
        title: "Feedback sent",
        message: "The message was delivered to the configured inbox."
      });
    } catch (error) {
      pushToast({
        tone: "error",
        title: "Feedback failed",
        message: error.message,
        copyText: error.stack ?? error.message
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section className="info-panel feedback-panel" id="feedback">
      <div className="section-kicker">Feedback</div>
      <h2>Send a note to the root inbox</h2>
      <p className="form-note">
        Send a short note about bugs, confusing copy, or anything that should change before launch.
      </p>
      <form className="feedback-form" onSubmit={handleSubmit}>
        <label className="field-label" htmlFor="feedback-message">
          Message
        </label>
        <textarea
          id="feedback-message"
          value={message}
          onChange={(event) => setMessage(event.target.value)}
          placeholder="What should change in the UI, UX, or operational path?"
          rows={5}
        />
        <div className="form-row">
          <button type="submit" disabled={isSending || !message.trim()}>
            {isSending ? "Sending..." : "Send feedback"}
          </button>
          <p className="form-note">Your message is submitted through the feedback form.</p>
        </div>
      </form>
    </section>
  );
}
